/* What an agent's Voice settings pick from (`GET /calls/speech`, backend/modules/calls): the
   speech models it hears and speaks with, the voices it can talk in, and the defaults. */
import { useQuery } from "@tanstack/react-query";

import { client } from "./client";
import { unwrap, type Envelope } from "./envelope";

export interface SpeechModel {
  id: string;
  name: string;
  provider: string;
  /** what the picker says beside the name, when the catalog has it */
  about?: string;
}

export interface Voice {
  id: string;
  name: string;
  description: string;
  preview_url: string | null;
}

export interface SpeechOptions {
  /** whether this server carries calls (Agora and the speech provider are set up) */
  on: boolean;
  listen: SpeechModel[];
  speak: SpeechModel[];
  voices: Voice[];
  defaults: { listen: string; speak: string; voice: string };
}

export const speechKeys = { options: ["speech", "options"] as const };

export async function getSpeechOptions(): Promise<SpeechOptions> {
  return unwrap(await client.get<Envelope<SpeechOptions>>("/calls/speech"));
}

export const useSpeechOptions = () =>
  useQuery({ queryKey: speechKeys.options, queryFn: getSpeechOptions, staleTime: 10 * 60_000 });
